/*
 * @Author: Risker-C
 * @Date: 2021-09-13 16:06:42
 * @LastEditTime: 2021-09-18 10:52:13
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\components\YhFormBox\item\FormFileImage.tsx
 */
import React, { FC, useState, useEffect } from "react";
import { IFormItem } from "../Types";
import { Badge, Upload, Button, Image, Form, Input } from "antd";
import { CloseCircleOutlined } from '@ant-design/icons';
import { UploadChangeParam } from "antd/lib/upload";
import { COSUploadFile, getCOSFileUrl } from "@/utils/uploadFile";
import { RcCustomRequestOptions } from "antd/lib/upload/interface";

// export const fileUrl = "https://file-server.laoniuche.cn"; //生产
export const __FormFileImage: FC<IFormItem> = ({ md5List = [], isOne = false, onSetFieldsValue, ...props }) => {
    const [previewImage, setpreviewImage] = useState<string[]>(md5List); //商品缩略图

    // 图片上传
    const handleImgChange = (info: UploadChangeParam) => {
        if (info.file.status === "done") {
            let originImg = [...previewImage];
            let md5 = info.file.response.retData as string;
            if (isOne) {
                setpreviewImage([md5])
            } else {
                originImg.push(md5)
                setpreviewImage(originImg)
            }

        }
    };

    const onUpload = (options: RcCustomRequestOptions) => {
        COSUploadFile({
            options,
            onSuccess: (url, md5) => {
                console.log(url)
                let originImg = [...previewImage];
                if (isOne) {
                    setpreviewImage([md5])
                } else {
                    originImg.push(md5)
                    setpreviewImage(originImg)
                }
                onSetFieldsValue?.({ [props.fieldName]: originImg })
                // setFormData({ ...formData, md5, url })
            },
            // prefix: 'wms',
            onError: (error) => console.log(error),
            // onMD5Progress: setPercent({ ...percent, parsePercent: parseInt(Number(progress) * 100 + '') }),
            // onProgress: setPercent({ ...percent, uploadPercent: parseInt(Number(info.percent) * 100 + '') })
        })
    }

    useEffect(() => {
        setpreviewImage(md5List)
    }, [md5List])

    useEffect(() => {
        onSetFieldsValue && onSetFieldsValue({ [props.fieldName]: previewImage })
    }, [previewImage]);

    return (
        <>
            <Form.Item name={props.fieldName} hidden><Input /></Form.Item>
            <Form.Item
                label={props.fieldLabel}
                rules={props.rules}
                labelCol={props.labelCol}
            >
                {previewImage && previewImage.map((item, index) => (
                    <div key={index} className="img-file-box">
                        <Badge
                            count={props.disable ? null : <CloseCircleOutlined style={{ color: '#f5222d' }} onClick={(e) => {
                                e.stopPropagation()
                                let originImg = previewImage.filter(imgMd5 => imgMd5 !== item);
                                // console.log(originImg, item)
                                setpreviewImage(originImg);
                            }} />}
                        >
                            <Image src={getCOSFileUrl(item)} />
                        </Badge>
                    </div>
                ))}
                {!props.disable && <Upload
                    disabled={props.disable}
                    name='file'
                    showUploadList={false}
                    // action={`${fileUrl}/file/uploadFile`}
                    // onChange={handleImgChange}
                    customRequest={onUpload}
                >
                    <Button type="link" disabled={props.disable}>上传</Button>
                </Upload>}
            </Form.Item>
        </>
    )
}
